import AvailabilityInput from "components/Input/AvailabilityInput"
import SkeletonElement from "components/Table/components/SkeletonElement"
import { BUILDER_CONFIG, CONFIG_CUSTOMIZATION, CUSTOMIZATION_SHOW_IN_STOCK_FILTER } from "constants/constants"
import { useAppContext } from "contexts/AppContext"
import { Dispatch, SetStateAction } from "react"
import Utils from "Services/Utils"
import { TResultProduct } from "types"

type MyProps = {
    isLoading?: boolean,
    isCategoryNotDone?: boolean
    compatioProducts: TResultProduct[]
    availabilityFlag: boolean
    initialLoading: boolean
    countLoading: boolean
    // show availability checkbox if there are no products and availabilty flag is turned on
    showAvailabilityFlag?: boolean 
    setAvailabilityFlag: Dispatch<SetStateAction<boolean>>
}

const AvailabilityComponent = ({
    isCategoryNotDone,
    showAvailabilityFlag,
    availabilityFlag,
    initialLoading,
    countLoading,
    isLoading,
    compatioProducts,
    setAvailabilityFlag,
}: MyProps) => {
    const {builderSpec} = useAppContext()

    // if category product is selected
    // not ecommerce (no availability otherwise)
    // and show availability checkbox if there are no products and availabilty flag is turned on
    if(
        !isCategoryNotDone 
        || !Utils.checkIfClientWebsite() 
        || !showAvailabilityFlag
        || builderSpec?.[BUILDER_CONFIG]?.[CONFIG_CUSTOMIZATION]?.[CUSTOMIZATION_SHOW_IN_STOCK_FILTER] === false
    ) return <></>

    return (
        <div className="sb3-flex sb3-flex-col-reverse sb3-items-end sm:sb3-items-center sm:sb3-flex-row sb3-justify-between sb3-space-x-2 sb3-pt-2 sb3-flex-wrap sb3-font-semibold">
            <div>
                { 
                    availabilityFlag && 
                    <span className="sb3-flex sb3-text-sm sb3-text-gray-extraDark sb3-items-center sb3-space-x-2">
                        <span>{((initialLoading || isLoading || countLoading)) ? <SkeletonElement type={"sb3-title !sb3-w-9 sb3-bg-gray-100 sb3-animate-pulse"}/> : (compatioProducts.length < 50 ? compatioProducts.length : '50+')}</span> 
                        <span>IN STOCK models Available</span>
                    </span>
                }
            </div>

            <AvailabilityInput
                availabilityFlag={availabilityFlag}
                setAvailabilityFlag={setAvailabilityFlag}
            />
        </div>
    )
}

export default AvailabilityComponent